import React from 'react';
import PropTypes from 'prop-types';

const BenMobilePayee = ({ results, content, onMobRowSelect }) => {
  return (
    <div>
      {results.map((resultData, index) => {
        return (
          <table
            className="beneficiary-table beneficiary-table-xsmall"
            cellPadding="0"
            cellSpacing="0"
            key={`BenMobilePayee_resultData_${index}`}
          >
            <tbody
              className="beneficiary-table__is-clickable"
              onClick={() => onMobRowSelect(resultData, !resultData.isSelected)}
            >
              <tr>
                <th />
                <th>{content.benSyncColumnHeaderName}</th>
                <td key={resultData.name}>
                  <div>{resultData.name}</div>
                </td>
              </tr>
              <tr>
                <th />
                <th>{content.benSyncColumnHeaderNickname}</th>
                <td key={resultData.nickname}>
                  <div>{resultData.nickname}</div>
                </td>
              </tr>
              <tr>
                <th scope="col" className="selection-column">
                  <div className="option-select">
                    <input
                      type="checkbox"
                      name="checkbox"
                      checked={resultData.isSelected}
                    />
                    <label />
                  </div>
                </th>
                <th>{content.benSyncColumnHeaderAccNo}</th>
                <td key={resultData.accountNoForDisplay}>
                  <div>{resultData.accountNoForDisplay}</div>
                </td>
              </tr>
              <tr>
                <th />
                <th>{content.benSyncColumnHeaderReference}</th>
                <td key={resultData.reference}>
                  <div>{resultData.reference}</div>
                </td>
              </tr>
            </tbody>
          </table>
        );
      })}
    </div>
  );
};

BenMobilePayee.defaultProps = {
  results: [],
};

BenMobilePayee.propTypes = {
  content: PropTypes.object,
  results: PropTypes.object.isRequired,
  onMobRowSelect: PropTypes.func.isRequired,
};

export default BenMobilePayee;
